module.exports = __webpack_public_path__ + "static/media/Week11.5c9a33a6.pdf";